import clsx from 'clsx'
import React from 'react'

import AngleRight from '@Assets/SVG/AngleRight'
import BagThinIcon from '@Assets/SVG/BagThin'
import { SVGIcon } from '@Components/Icons/SVGIcon'
import styles from '@Domains/Checkout/OrderSummary/OrderSummaryTrigger.module.scss'
import { Money } from '@Globals/Money'
import { useSplitTest } from '@Globals/SplitTests/Hooks'
import { useTranslation } from '@Globals/Translations'

interface OrderSummaryV2Props {
  grandTotal: Money
  onClick: () => void
}

export const OrderSummaryTriggerV2 = ({ grandTotal, onClick }: OrderSummaryV2Props) => {
  const cofDesignV1 = useSplitTest('cof_design_v1', 'b')
  const { t } = useTranslation()
  return (
    <button className={clsx(styles.orderSummaryTrigger, cofDesignV1 && styles.cofDesignV1)} onClick={onClick} type="button">
      <span>
        <SVGIcon className={styles.icon} icon={BagThinIcon} />
        {t('common:COF_ORDER_SUMMARY')}
      </span>

      <span>
        {(grandTotal.value === 0) ? t('checkout:COF_FREE') : grandTotal.format}
        <SVGIcon className={styles.icon} icon={AngleRight} />
      </span>
    </button>
  )
}
